export default __webpack_public_path__ + "2ddb5218892b9c3715d65279a1e8ec24.png";